import { AuthFlowError, ChangeEmailErrorKind } from '@griply/types';
import { useMutation } from '@tanstack/react-query';
import { requestEmailChange } from 'shared/services/backend-api';

export const useRequestEmailChangeMutation = () =>
  useMutation<
    void,
    AuthFlowError<ChangeEmailErrorKind>,
    { newEmail: string; password: string }
  >({
    mutationFn: ({ newEmail, password }) =>
      requestEmailChange(newEmail, password),
  });
